module.exports = __webpack_public_path__ + "static/media/icon2.af82c91b.svg";